import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

export const LanguageSelector = () => {
  const { i18n, t } = useTranslation();

  const LANGUAGES = [
    { code: "en", label: t("languages.english"), flag: "🇬🇧" },
    { code: "es", label: t("languages.spanish"), flag: "🇪🇸" },
    { code: "fr", label: t("languages.french"), flag: "🇫🇷" },
  ];
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLanguage =
    LANGUAGES.find((lang) => lang.code === i18n.language) || LANGUAGES[0];

  const handleLanguageChange = (e, languageCode) => {
    e.preventDefault();
    e.stopPropagation();
    i18n.changeLanguage(languageCode);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="gpc-language-selector" ref={dropdownRef}>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsOpen(!isOpen);
        }}
        className="gpc-header-button gpc-focus-visible gpc-transition"
        aria-label={t("ui.languageSelector.label")}
        title={t("ui.languageSelector.label")}
      >
        <Globe className="gpc-icon" />
      </button>

      {isOpen && (
        <div className="gpc-language-dropdown">
          {LANGUAGES.map((lang) => (
            <button
              key={lang.code}
              type="button"
              onClick={(e) => handleLanguageChange(e, lang.code)}
              className={`gpc-language-option ${
                lang.code === currentLanguage.code
                  ? "gpc-language-option-active"
                  : ""
              }`}
            >
              <span className="gpc-language-flag">{lang.flag}</span>
              <span className="gpc-language-label">{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};